import { getHours, set, differenceInMinutes, getMinutes, addMinutes } from "date-fns";
const getSlotsForDuration = (minutes) => {
  const tenMinutes = 10;
  const fifteenMinutes = 15;
  if (minutes <= 60) {
    return {
      slots: Math.floor(minutes / tenMinutes),
      interval: tenMinutes
    };
  }
  return {
    slots: Math.floor(minutes / fifteenMinutes),
    interval: fifteenMinutes
  };
};
const formatDigits = (value) => {
  return value.toString().padStart(2, "0");
};
const generateInterval = (data) => {
  const { start, end, showExtendedView } = data;
  if (!showExtendedView) {
    const startTime = getHours(start);
    const endTime = getHours(end);
    if (start > end) {
      throw new Error("startHour cannot be larger than endHour");
    }
    return Array.from({ length: endTime - startTime }).map((_, index) => {
      const hour = startTime + index;
      return `${hour}:00`;
    });
  }
  const startDate = typeof start === "number" ? set(/* @__PURE__ */ new Date(), { hours: start }) : start;
  const endDate = typeof end === "number" ? set(/* @__PURE__ */ new Date(), { hours: end }) : end;
  const minutes = differenceInMinutes(endDate, startDate);
  const slots = getSlotsForDuration(minutes);
  return Array.from({ length: slots.slots < 3 ? 3 : slots.slots + 1 }).map((_, index, list) => {
    const isLast = index === list.length - 1;
    const isFirst = index === 0;
    if (isFirst) {
      return `${formatDigits(getHours(startDate))}:${formatDigits(getMinutes(startDate))}`;
    }
    if (isLast) {
      return `${formatDigits(getHours(endDate))}:${formatDigits(getMinutes(endDate))}`;
    }
    const slotDate = addMinutes(startDate, slots.interval * index);
    return `${formatDigits(getHours(slotDate))}:${formatDigits(getMinutes(slotDate))}`;
  });
};
export {
  generateInterval
};
